import ApolloDataExportItem from '../../../Domain/ApolloDataExportItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ApolloDataExportService from '../../../Services/ApolloDataExportService';

// Drives the GeneralEditWizzardBaseFigma create/edit wizard for Apollo data exports.
// Seven fields keep it in the full-screen wizard layout (only <=6-field pages go compact).
export default class ApolloDataExportWindowDescription {
  static titleForCreate = 'Add New ApolloDataExport';
  static titleForEdit = 'Edit ApolloDataExport';
  static entityName = 'ApolloDataExport';
  static idField = 'ApolloDataExportId';
  static nameField = 'ClientName';
  static itemType = ApolloDataExportItem;
  static serviceFunction = ApolloDataExportService.EditApolloDataExport;
  static messageOnSuccess = 'ApolloDataExport has been saved.';
  static finishButtonLabel = 'Save ApolloDataExport';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ClientName',
          label: 'Query Name',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Frequency',
          label: 'Frequency',
          className: 'col-4',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.forRequiredTextField,
          selectvalues: () => ApolloDataExportItem.getFrequencySelectOptions(),
        },
        {
          fieldName: 'Query',
          label: 'Query',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'EmailRecipients',
          label: 'Email Recipients',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'StartDate',
          label: 'Start Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.Frequency === 'On-Demand',
        },
        {
          fieldName: 'EndDate',
          label: 'End Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.Frequency === 'On-Demand',
        },
      ],
    },
  ];
}
